import { Card, Col, Row, Typography, Input, Form, Button, Steps } from "antd";
import { Container } from "reactstrap";
import React, { useContext, useState, useEffect, useRef } from "react";
import { PublicContext } from "../PublicContext";
import "./Order.css";
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export default function OrderStatus() {
    const location = useLocation();
    const [queryParams, setQueryParams] = useState(queryString.parse(location.search));
    let orderId = queryParams.OrderId;
    let email = queryParams.Email;
    const [loading, setLoading] = useState(true);
    const [order, setOrder] = useState({});
    const [product, setProduct] = useState({});
    const [menuProduct, setMenuProduct] = useState({});
    const { stores, setSpinning } = useContext(PublicContext);
    const [storeInfo, setStoreInfo] = useState({
        storePhone: "",
        storeName: "",
    });
    const [orderStatus, setOrderStatus] = useState(0);
    const [needInfo, setNeedInfo] = useState(null);
    const [form] = Form.useForm();
    const [isCheckingStatus, setIsCheckingStatus] = useState(false);
    const [wrongInfo, setWrongInfo] = useState(null);

    //const refreshCount = useRef(0);

    useEffect(() => {
        //console.log("needInfo useEffect " + refreshCount.current);
        if (needInfo !== null) {
            const refreshCount = parseInt(localStorage.getItem('refreshCount')) || 0;
            if (Object.keys(queryParams).length === 2 && refreshCount < 1) {
                const interval = setInterval(() => {
                    if (refreshCount < 1) {
                        localStorage.setItem('refreshCount', refreshCount + 1);
                        window.location.reload();
                    } else {
                        clearInterval(interval); // Clear the interval after 3 refreshes
                    }
                }, 2000); //  + Math.random() * 1000 for 2000ms to 3000ms

                return () => {
                    localStorage.setItem('refreshCount', 0);
                    clearInterval(interval); // Cleanup on component unmount
                }
            }

            //if (refreshCount === 2) {
            //    setNeedInfo(true);
            //}
        }
    }, [needInfo]);

    useEffect(() => {
        //console.log("order status use effect");
        //console.log(queryParams);
        orderId = queryParams.OrderId;
        email = queryParams.Email;
        if (stores.length > 0) {
            if (orderId && email) {
                setSpinning(true);
                fetchOrder();
            }
            else {
                //console.log("no customerinfo");
                setNeedInfo(true);
            }
        }
        else {
            window.location.reload();
        }
    }, [stores, queryParams]);

    useEffect(() => {
        let intervalId;
        clearInterval(intervalId);
        // Function to check order status
        const checkOrderStatus = () => {
            // Your logic to check order status goes here
            fetchOrder();
            //console.log("Checking order status...");
        };

        // Start checking order status when isCheckingStatus becomes true
        if (isCheckingStatus && orderId && email) {
            if (orderStatus === 100 || orderStatus === 400 || orderStatus === 401 || orderStatus === 500) {
            }
            else {
                intervalId = setInterval(checkOrderStatus, 120000); // Check every 120 seconds

                // Clear interval and reset flag when component unmounts or isCheckingStatus becomes false
                return () => {
                    clearInterval(intervalId);
                    setIsCheckingStatus(false);
                };
            }
        }

        // Cleanup function when component unmounts
        return () => {
            clearInterval(intervalId);
        };
    }, [isCheckingStatus, orderId]);

    async function fetchOrder() {
        //console.log("Start Downloading order");
        //const response = await fetch(
        //    "api/Orders/" + localStorage.getItem("orderId")
        //);
        await fetch(`api/Orders/GetOrder?OrderId=${orderId}&Email=${email}`, {
            //await fetch("api/Orders/InitPayment", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            //body: JSON.stringify(order),
        })
            .then(async (response) => {
                const data = await response.json();
                // console.log("order loaded");
                // console.log(data);
                setOrder(data.orders);
                setProduct(data.orderProducts);
                setOrderStatus(data.orders.orderStatus);
                var store = stores.find(store => store.storeId === data.orders.storeId)
                //console.log(store);
                setStoreInfo({
                    storePhone: store.storePhone,
                    storeName: store.storeName,
                });
                setMenuProduct(JSON.parse(localStorage.getItem("products")));
                setLoading(false);
                if (!isCheckingStatus) {
                    setIsCheckingStatus(true);
                }
                setNeedInfo(false);
                setSpinning(false);
            })
            .catch((error) => {
                setNeedInfo(true);
                setSpinning(false);
                //console.error(error);
            });
    }
    async function submitOrder() {
        setSpinning(true);
        setWrongInfo(false);
        try {
            const values = await form.validateFields();
            //Perform form submission logic here
            //console.log(values);

            await fetch(`api/Orders/GetOrder?OrderId=${values.orderid}&Email=${values.email}`, {
                //await fetch("api/Orders/InitPayment", {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-type": "application/json",
                },
                //body: JSON.stringify(order),
            })
                .then(async (response) => {
                    const data = await response.json();
                    //console.log(data);
                    //console.log("order loaded");
                    orderId = values.orderid;
                    email = values.email;
                    setOrder(data.orders);
                    setProduct(data.orderProducts);
                    var store = stores.find(store => store.storeId === data.orders.storeId)
                    //console.log(store);
                    setStoreInfo({
                        storePhone: store.storePhone,
                        storeName: store.storeName,
                    });
                    setMenuProduct(JSON.parse(localStorage.getItem("products")));
                    setNeedInfo(false);
                    // localStorage.setItem("storeList", JSON.stringify(data));
                    // setDeliveryOrPickUp(localStorage.getItem("deliveryOrPickUp"));
                    // console.log(deliveryOrPickUp);
                    //addDZtoStore(data)
                    setSpinning(false);

                    setLoading(false);
                    if (!isCheckingStatus) {
                        setIsCheckingStatus(true);
                    }
                })
                .catch((error) => {
                    setSpinning(false);
                    setWrongInfo(true);
                    //console.error(error);
                });
        } catch (error) {
            //console.error("Form submission failed:", error);
        }
    }

    const handleValuesChange = (changedValues, allValues) => {
        // setFormValues(allValues);
        sessionStorage.setItem("orderStatusInfo", JSON.stringify(allValues));
    };

    const renderOrderStages = () => {
        const stages = [
            {
                orderStatus: 0,
                title: "Processing",
                //description: "Your order has been successfully submitted! "
            },
            {
                orderStatus: 1,
                title: "Accepted",
                //description: "Your order has been accepted!"
            },
            //{
            //    orderStatus: 2,
            //    title: order.orderType === "pickup" ? "Ready for Pickup" : "", // Skip Ready for Pickup stage if orderType is delivery
            //    //description: order.orderType === "pickup" ? "" : "Your order is ready for pickup!"
            //},
            //{
            //    orderStatus: 3,
            //    title: order.orderType === "delivery" ? "Delivering" : "", // Skip Delivering stage if orderType is pickup
            //    //description: order.orderType === "delivery" ? "" : "Your order is on the way!"
            //},
            {
                orderStatus: 100,
                //title: order.orderType === "pickup" ? "Picked Up" : "Delivered",
                title: "Completed",
                //description: "Your order has been completed! We hope you enjoy your meal!"
            },
            {
                orderStatus: 400,
                title: "Not Accepted",
                description: "Unfortunately, we cannot accept your order! Please contact us at " + storeInfo.storePhone
            },
            {
                orderStatus: 500,
                title: "Refunded",
                description: "Your order is being refunded. You will be refunded within 5 business days."
            }
        ];

        // Filter out empty stages and the Rejected stage if the orderStatus is not 400
        const filteredStages = stages.filter(stage => {
            // Show Rejected stage only if orderStatus is 400 or 500
            //console.log(stage.orderStatus + " " + orderStatus);
            if (stage.orderStatus === 400 || stage.orderStatus === 500) {
                return orderStatus === stage.orderStatus;
            }
            return stage.title !== ""; // Filter out empty stages
        });

        // Find the current stage based on the orderStatus
        const currentStage = filteredStages.find(stage => stage.orderStatus === orderStatus);

        // If the order status is Rejected, show only the Rejected stage
        if (orderStatus === 400 || orderStatus === 500) {
            return (
                <Steps current={0}>
                    <Steps.Step
                        key={currentStage.orderStatus}
                        title={currentStage.title}
                        description={currentStage.description}
                        status="error" // Set status to "error" for rejected stage
                    />
                </Steps>
            );
        }

        // Determine the current stage index
        const currentStageIndex = filteredStages.findIndex(stage => stage.orderStatus === orderStatus);

        return (
            <Steps current={currentStageIndex}>
                {filteredStages.map((stage, index) => (
                    <Steps.Step
                        key={stage.orderStatus}
                        title={stage.title}
                        description={stage.description}
                    />
                ))}
            </Steps>
        );
    };
    function renderCartList() {
        return (
            <>
                {loading ? (
                    <></>
                ) : (
                    <>
                        {product.map((item, index) => (
                            <div key={item.productCode + "_" + item.subtotal}>
                                <Row className="d-flex justify-content-between align-items-center">
                                    <Col xs={8} xl={4} className="w-100">
                                        <img
                                            width="100px"
                                            alt={item.productName}
                                            src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${menuProduct.find(mp => mp.productCode === item.productCode).pictureURL}`}
                                            className="rounded-3"
                                            onError={(e) => {
                                                e.target.src = "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png";
                                                e.target.onerror = null;
                                            }}
                                        />
                                    </Col>
                                    <Col xs={16} xl={8} className="w-100">
                                        <Typography className="text-muted">Category</Typography>
                                        <Typography level={5} className="text-black flex-wrap">
                                            {item.productName}
                                        </Typography>
                                    </Col>
                                    <Col
                                        xs={6}
                                        xl={6}
                                        className="w-100 d-flex align-items-center"
                                    >
                                        <Typography level={5} className="text-black flex-wrap">
                                            {item.quantity}
                                        </Typography>
                                    </Col>
                                    <Col xs={6} xl={3} className="w-100">
                                        <Typography tag="h6" className="mb-0">
                                            $ {item.subtotal}
                                        </Typography>
                                    </Col>
                                </Row>
                                <hr className="my-4" />
                            </div>
                        ))}
                    </>
                )
                }
            </>
        );
    }

    return (
        <Container>
            {wrongInfo != null && wrongInfo && <Typography>Wrong order information entered, please try again.</Typography>}

            {((needInfo == null) || (needInfo != null && needInfo)) ?
                <>
                    <Typography>Enter the order Id and the email used for that order to retrieve the order status.</Typography>
                    <Form
                        form={form}
                        name="orderInfoForm"
                        onFinish={submitOrder}
                        onValuesChange={handleValuesChange}
                        layout="vertical"
                    >
                        <Form.Item
                            label="Order Id"
                            name="orderid"
                            rules={[{ required: true, message: "Order Id is required" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: "Email is required" },
                                { type: "email", message: "Valid Email is required" },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Button type="submit" className="btn-primary" onClick={() => submitOrder()}>Get Order Status</Button>
                    </Form>
                </>
                :
                <div className="py-5 h-100">
                    <Row className="justify-content-center align-items-center h-100">
                        <Col md={24} lg={24} xl={24}>
                            <Row>
                                <Col xs={24} xl={16}>
                                    <div className="px-3">
                                        <div className="d-flex justify-content-between align-items-center mb-5">
                                            <Typography tag="h1" className="fw-bold mb-0 text-black">
                                                Order # {order.orderId}
                                            </Typography>
                                        </div>

                                        <hr className="my-4" />
                                        {order.orderStatus === 0 &&
                                            <Card>Thank you for your business, we have received your order. You'll receive the order status by email{order.isOptIn && <> and text messages</>}.</Card>
                                        }

                                        <Card>{order && renderOrderStages()}</Card>

                                        <Card>{product && renderCartList()}</Card>
                                    </div>
                                </Col>
                                <Col xs={24} xl={8} className="bg-grey">
                                    <div className="p-5">
                                        <Typography tag="h3" className="fw-bold mb-5 mt-2 pt-1">
                                            Summary
                                        </Typography>

                                        <hr className="my-4" />

                                        <div className="d-flex justify-content-between mb-4">
                                            <Typography tag="h5" className="text-uppercase">
                                                item{product.length > 1 && <>s</>} x {product.length}
                                            </Typography>
                                            <Typography tag="h5">$ {order.subtotal.toFixed(2)}</Typography>
                                        </div>

                                        {order.orderType === "delivery" &&
                                            <div className="d-flex justify-content-between mb-4">
                                                <Typography tag="h5" className="text-uppercase">
                                                    Delivery Fee:
                                                </Typography>
                                                <Typography tag="h5">$ {order.deliveryFee.toFixed(2)}</Typography>
                                            </div>
                                        }

                                        <div className="d-flex justify-content-between mb-5">
                                            <Typography tag="h5" className="text-uppercase">
                                                Total savings:
                                            </Typography>
                                            <Typography tag="h5">$ {order.totalDiscount.toFixed(2)}</Typography>
                                        </div>

                                        <div className="d-flex justify-content-between mb-4">
                                            <Typography tag="h5" className="text-uppercase">
                                                Total before taxes:
                                            </Typography>
                                            <Typography tag="h5">$ {order.net.toFixed(2)}</Typography>
                                        </div>

                                        <div className="d-flex justify-content-between mb-4">
                                            <Typography tag="h5" className="text-uppercase">
                                                Estimated Taxes:
                                            </Typography>
                                            <Typography tag="h5">$ {order.taxValue.toFixed(2)}</Typography>
                                        </div>

                                        <div className="d-flex justify-content-between mb-4">
                                            <Typography tag="h5" className="text-uppercase">
                                                Tips:
                                            </Typography>
                                            <Typography tag="h5">$ {order.tips.toFixed(2)}</Typography>
                                        </div>

                                        <hr className="my-4" />

                                        <div className="d-flex justify-content-between mb-5">
                                            <Typography tag="h5" className="text-uppercase">
                                                Total:
                                            </Typography>
                                            <Typography tag="h5">$ {(order.totalPrice + order.tips).toFixed(2)}</Typography>
                                        </div>
                                    </div>
                                    <div className="p-5">
                                        <div className="d-flex justify-content-between mb-4">
                                            <Typography tag="h5">
                                                If you wish to cancel this order, please call the{" "}
                                                {storeInfo.storeName} location at {storeInfo.storePhone}.
                                            </Typography>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            }
        </Container>
    );
}
